import { showAlert } from "../Alerts";

const parseJson = (str) => {
  try {
    return JSON.parse(str);
  } catch (error) {
    return false; // If an error occurs, it's not JSON
  }
}

export const APICall = async (url, method = 'POST', body = null, headers = {}) => {
  try {
    const response = await fetch(url, {
      method: method,
      headers: headers,
      body: body,
      credentials: 'include'
    });

    var jsonData = await response.json(); // Parse JSON response
    if (!response.ok) {
      if (jsonData?.Errors) {
        if (jsonData?.Errors?.[0].message.includes("InvalidAccessTokenException")) {
          throw new Error(`${JSON.stringify({ heading: "Session Expired", message: "Please login again your session is expired", status: response.status })}`);
        } else {
          throw new Error(`${JSON.stringify({ heading: "HTTP error!", message: "Something Went Wrong", status: response.status })}`);
        }
      }
    }
    // console.log("jsonData",jsonData)

    return jsonData;
  } catch (error) {
    if (error.response) {
      console.error('API error response:', error.response);
      showAlert(
        "Server Validations failed",
        `${error.message ?? "Something Went Wrong"}`,
        'error'
      );
    } else if (error.request) {
      console.error('API no response:', error.request);
      showAlert(
        "Server Validations failed",
        `${error.message ?? "Something Went Wrong"}`,
        'error'
      );
      // throw new Error('API error: No response from server');
    } else {
      const parsedError = parseJson(error.message);
      if (parsedError !== false) {
        const { heading, message, status } = parsedError;
        showAlert(
          `${heading ?? "Server Error"} Status:${status ?? 500}`,
          `${message ?? "Something Went Wrong"}`,
          'error'
        );
        if (heading === "Session Expired") {
          alert(heading)
          localStorage.clear();
          window.location.href = process.env.REACT_APP_SERVER_BASE_FRONTEND_URL + "/" +REACT_APP_BASE_PATH;
        }
        return jsonData;
      }
      else {
        showAlert(
          "Server Validations failed",
          `${error.message ?? "Something Went Wrong"}`,
          'error'
        );
      }
    }
  }
};